import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const projects = [{
  image: 'https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=1200&q=80',
  title: 'Modern Kitchen Transformation'
}, {
  image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1200&q=80',
  title: 'Luxury Bathroom Renovation'
}, {
  image: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?w=1200&q=80',
  title: 'Contemporary Living Room'
}, {
  image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&q=80',
  title: 'High-End Flooring Installation'
}, {
  image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=1200&q=80',
  title: 'Complete House Renovation'
}];
export function Portfolio() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % projects.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + projects.length) % projects.length);
  };
  return <section id="portfolio" className="py-12 sm:py-16 md:py-20 bg-[#1c1c1c]" ref={ref} data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-12 md:mb-16" data-id="element-201">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-202">
            Our <span className="text-[#d4af37]" data-id="element-203">Projects</span>
          </h2>
          <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto px-4" data-id="element-204">
            Explore our portfolio of stunning transformations
          </p>
        </motion.div>
        <div className="relative" data-id="element-205">
          <AnimatePresence mode="wait" data-id="element-206">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 100
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -100
          }} transition={{
            duration: 0.5
          }} className="relative h-[300px] sm:h-[400px] md:h-[500px] rounded-lg overflow-hidden" data-id="element-207">
              <img src={projects[currentIndex].image} alt={projects[currentIndex].title} className="w-full h-full object-cover" data-id="element-208" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1c1c1c]/90 to-transparent flex items-end" data-id="element-209">
                <div className="p-4 sm:p-6 md:p-8 w-full" data-id="element-210">
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white" data-id="element-211">
                    {projects[currentIndex].title}
                  </h3>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
          {/* Navigation Buttons */}
          <button onClick={prevSlide} className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 bg-[#d4af37] rounded-full flex items-center justify-center hover:bg-[#4b4bff] transition-colors duration-300 active:scale-90 touch-manipulation" data-id="element-212">
            <ChevronLeftIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#1c1c1c]" data-id="element-213" />
          </button>
          <button onClick={nextSlide} className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 bg-[#d4af37] rounded-full flex items-center justify-center hover:bg-[#4b4bff] transition-colors duration-300 active:scale-90 touch-manipulation" data-id="element-214">
            <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#1c1c1c]" data-id="element-215" />
          </button>
          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4 sm:mt-6" data-id="element-216">
            {projects.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 sm:h-3 rounded-full transition-all duration-300 touch-manipulation ${index === currentIndex ? 'bg-[#d4af37] w-6 sm:w-8' : 'bg-gray-600 w-2 sm:w-3'}`} data-id="element-217" />)}
          </div>
        </div>
      </div>
    </section>;
}